const plugin = require('tailwindcss/plugin');

/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './pages/**/*.{js,ts,jsx,tsx,mdx}',
    './components/**/*.{js,ts,jsx,tsx,mdx}',
    './app/**/*.{js,ts,jsx,tsx,mdx}',
  ],
  theme: {
    extend: {
      fontFamily: {
        firaSans: ['var(--font-lato)'],
        playfair: ['var(--font-playfair)'],
      },
      backgroundImage: {
        'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
        'gradient-conic':
          'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))',
      },
      colors: {
        // 'maincolor': '#1b2f6b',
        'backgroundcolor': 'var(--backgroundcolor)',
        'navbartext': 'var(--navbartext)',
        'maincolor': 'var(--maincolor)',
        'maincolortrans': '#2331424d',
        // 'secondary': '#015B97',
        // 'secondary': '#05294d',
        'secondary': 'var(--secondarycolor)',
        // 'third': '#941109',
        'third': 'var(--thirdcolor)',
        // 'price': '#941109',
        'price': 'var(--pricecolor)',
        'forth': 'var(--fourthcolor)',
        'light': 'white',
        'navlight': '#D3D3D3',
        'mainhover': 'gray',
        'layover': 'var(--layovercolor)',
        'content': 'var(--textcolor)',
        'label': 'var(--labelcolor)',
        'labelhighlight': 'var(--labelhighlightcolor)',
        'icon': 'var(--iconcolor)',

      },
      backgroundColor: ['hover'],
    },
  },
  plugins: [
    plugin(function ({ addComponents, addUtilities, addBase, theme }) {
      addBase({
        'html': {
          fontFamily: theme('fontFamily.lato'),
        },
        'h1': {
          fontFamily: theme('fontFamily.playfair'),
          color: theme('colors.maincolor'),
          letterSpacing: theme('letterSpacing.wide')  
        },
        'h2': {
          fontFamily: theme('fontFamily.playfair'),
          color: theme('colors.maincolor'),
          letterSpacing: theme('letterSpacing.wide')
        },
        'strong': {
          fontFamily: theme('fontFamily.playfair'),
          // color: theme('colors.price'),
        },
        'nav': {
          fontFamily: theme('fontFamily.playfair'),
          letterSpacing: theme('letterSpacing.wide')
          // color: theme('colors.price'),
        },
        // 'nav': {
        //   fontFamily: theme('fontFamily.playfair'),
        //   // color: theme('colors.price'),
        // },
        'p': {
          fontFamily: theme('fontFamily.lato'),
          color: theme('colors.secondary'),
        },
      }),
      addComponents({
        '.card-unliked': {
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          top: '0.25rem', // top-1
          right: '0.25rem', // right-1
          zIndex: '40',
          height: '2rem', // h-8
          width: '2rem', // w-8
          justifyContent: 'center',
          alignItems: 'center',
          borderWidth: '1px',
          borderColor: theme('colors.price'),
          borderRadius: '0.375rem', // rounded-md
          padding: '0.25rem', // p-1
        },
        '.card-liked': {
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          top: theme('spacing.1'),
          right: theme('spacing.1'),
          zIndex: 40,
          height: theme('spacing.8'),
          width: theme('spacing.8'),
          justifyContent: 'center',
          alignItems: 'center',
          borderWidth: '1px',
          color: theme('colors.price'),
          borderColor: theme('colors.price'),
          borderRadius: theme('borderRadius.md'),
          padding: theme('spacing.1'),
        },
        '.label': {
          position: 'absolute',
          bottom: theme('spacing.1'),
          left: theme('spacing.1'),
          backgroundColor: theme('colors.label'),
          color: theme('colors.light'),
          padding: theme('spacing.1'),
          borderRadius: theme('borderRadius.md'),
          zIndex: 10,
          // fontWeight: theme('fontWeight.semibold'),
        },
        '.label-highlight': {
          position: 'absolute',
          bottom: theme('spacing.1'),
          left: theme('spacing.1'),
          backgroundColor: theme('colors.labelhighlight'),
          color: theme('colors.light'),
          padding: theme('spacing.1'),
          borderRadius: theme('borderRadius.md'),
          zIndex: 10,
          // fontWeight: theme('fontWeight.semibold'),
        },
        '.transport-label-container': {
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          top: theme('spacing.1'),
          left: theme('spacing.1'),
          borderColor: 'black'
        },
        '.transport-label': {
          color: theme('colors.light'),
          borderRadius: theme('borderRadius.md'),
          fontSize: theme('fontSize.md'),
          padding: theme('spacing.1'),
          marginLeft: theme('spacing.1'),
          marginBottom: theme('spacing.1'),
        },
        '.large-card-image': {
          '@screen sm': {
            width: '300px',
          },
          width: '100%',
          objectFit: 'cover',
          aspectRatio: '4 / 3',
          borderRadius: theme('borderRadius.md'),
          overflow: 'hidden',
        },
        '.image-container': {
          position: 'relative',
          width: '250px',
          height: '187.5px',
          borderRadius: theme('borderRadius.md'),
          overflow: 'hidden',
        },
        '.form-label': {
          fontSize: theme('fontSize.sm'),
        },
        '.btn': {
          width: '100%',
          borderRadius: theme('borderRadius.md'),
          padding: theme('spacing.2'),
          color: theme('colors.light'),
          fontWeight: theme('fontWeight.bold'),
          fontFamily: theme('fontFamily.playfair'),
          letterSpacing: theme('letterSpacing.wide')  
        },
        '.submit-btn': {
          color: theme('colors.white'),
          backgroundColor: theme('colors.navbartext'),
          backgroundImage: 'linear-gradient(to right, #CAA134, #B3852F, #D7B037, #9C6E18, #BE8B3C)',
        },
        '.submit-btn:hover': {
          color: theme('colors.send'),
          backgroundColor: theme('colors.navbartext'),
          backgroundImage: 'linear-gradient(to right, #9C6E18, #BE8B3C, #CAA134, #B3852F, #D7B037)',
        },
        '.round-style': {
          borderRadius: theme('borderRadius.lg'),
        },
        '.gradient-aurix': {
          backgroundImage: 'linear-gradient(to right, #CAA134, #B3852F, #D7B037, #9C6E18, #BE8B3C)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          WebkitTextFillColor: 'transparent',
        },
        '.text-price': {
          backgroundImage: 'linear-gradient(to right, #EBC860, #E5A74E, #C7943B, #E5B155, #E2A83E)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          WebkitTextFillColor: 'transparent',
        },
        '.text-navbartext': {
          backgroundImage: 'linear-gradient(to right, #EBC860, #E5A74E, #C7943B, #E5B155, #E2A83E)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          WebkitTextFillColor: 'transparent',
        },

      });
    }),
  ],
}